export default __webpack_public_path__ + "static/media/Target-Amount-Calculator.6a361f78.png";